<fgb-page-header [pageTitle]="mobileTitle" [showBalance]="false"></fgb-page-header>
<div class="container">
  <div class="padding-top d-none d-lg-block">
    <div class="back-btn text-white cursor-pointer" (click)="back()">
      <span class="material-icons"> arrow_back_ios </span>
    </div>
  </div>
  <div class="pt-lg-3">
    <fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details>
  </div>
</div>
